import { AnimatedHeadline } from "@/components/Reveal";
import { Btn } from "@/components/Btn";
import WaveMark from "@/components/WaveMark";

export default function NotFound() {
  return (
    <section data-testid="not-found" className="relative flex min-h-screen items-center overflow-hidden bg-ink text-white">
      <div className="mx-auto w-full max-w-[1400px] px-6 md:px-12">
        <p className="text-[11px] uppercase tracking-label text-slate-mute">Error 404</p>
        <AnimatedHeadline
          immediate
          lines={["This page", "drifted away."]}
          className="mt-8 font-display text-6xl font-medium leading-[0.95] tracking-tight md:text-8xl"
        />
        <p className="mt-10 max-w-md text-lg leading-relaxed text-white/70">
          The page you're looking for doesn't exist or has moved. Let's get you back on course.
        </p>
        <div className="mt-12">
          <Btn to="/" testid="notfound-home">Back to home</Btn>
        </div>
      </div>
      <WaveMark width={520} stroke="rgba(255,255,255,0.05)" className="pointer-events-none absolute -bottom-16 -right-16 hidden lg:block" />
    </section>
  );
}
